<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="ngx-datatable-shipping">
      <div class="card">
        <div
          class="card-title d-flex justify-content-between align-items-center"
        >
        <div class="d-flex justify-content-between align-items-center">
          <button
            type="button"
            class="btn btn-icon btn-outline-primary mr-2"
            style="margin-left: 12px;"
            rippleEffect
            (click)="Back()"
          >
            <span [data-feather]="'arrow-left'"></span>
          </button>
      
          <h4 class="mt-2">{{headerMessage}} </h4>
        </div>
          <div>
            <!--<button
              class="btn btn-info mr-1"
              rippleEffect
              [routerLink]="['/pages/bash-to-flight']"
            >
              <i data-feather="clipboard" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block">A Vuelo en Lote </span>
            </button>
            <button
              class="btn btn-primary mr-1"
              rippleEffect
              [routerLink]="['/pages/bill-batch-create']"
            >
              <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block">Lote de Facturas</span>
            </button>
            <button type="button" [disabled]="this.fd.dealerId.value == null" class="btn btn-primary mr-1 text-nowrap" rippleEffect (click)="FetchModels()">
              <i data-feather="plus" class="mr-0 mr-sm-1"></i
                ><span class="d-none d-sm-inline-block text-nowrap">Cargar Facturas</span>
            </button>-->
            <button type="button" [disabled]="assignments.length == 0" placement="left" class="btn btn-icon btn-info pl-2 text-danger cursor-pointer mr-50" height="16"
              rippleEffect [ngbPopover]="popoverTemplate" #popOver="ngbPopover" placement="left-top" [autoClose]="'outside'">
              <span>
                <i class="fa fa-bars fa-lg" style="color:#ffff"></i>
                Filtrar
              </span></button>
            <button
              class="btn btn-primary mr-1 text-nowrap"              
              [disabled]="(!this.dispatchId && selectedRowIds.size == 0) || (this.searchForm.invalid || selectedRowIds.size == 0)"   
              rippleEffect   
              (click)="loadDispatchPreview()"                               
            >
            <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block text-nowrap">{{headerMessage}}</span>
            </button>           
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-12">
              <div
                class="d-flex justify-content-between align-items-center m-1"
              >
                <label class="d-flex align-items-center"
                  >Mostrando
                  <select
                    class="form-control mx-25"
                    [(ngModel)]="basicSelectedOption"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option [value]="assignments.length">
                      Todos
                    </option>
                  </select>
                  facturas</label
                >
              </div>
            </div>
            <div class="col-md-6 col-12 d-flex justify-content-md-end">
              <div
                class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0"
              >
                <label class="hidden d-flex align-items-center"
                  >Buscar<input
                    #searchInput
                    type="search"
                    placeholder="Código Factura"
                    class="form-control ml-25"                    
                /></label>
              </div>
            </div>
          </div>
          <form [formGroup]="searchForm">
            <div class="row">
              <div class="form-group col-md-3">
                <label class="form-label" for="select-flights">
                  <b class="text-primary">*</b> Nombre:
                </label>
                <input type="text" id="vertical-name" maxlength="15" class="form-control" placeholder="Nombre"
                                    formControlName="name" />
              </div>
              <div class="form-group col-md-3">
                <label class="form-label" for="vertical-language">
                  <b class="text-primary">*</b> Repartidores
                </label>
                <ng-select
                  [items]="dealers"
                  bindLabel="userName"
                  bindValue="id"
                  formControlName="dealerId"
                  (change)="OnDealerChange()"
                >
                </ng-select>
                <!--<label class="form-label" for="vertical-language">
                  <b class="text-primary">*</b> Envíos
                </label>
                <ng-select
                  [items]="shippings"
                  bindLabel="code"
                  bindValue="id"
                  formControlName="shippingId"                
                >
                </ng-select>-->
              </div>
              
              <div class="form-group col-md-3">
                
              </div>
              
            </div>
            <div class="row">
              <div class="col-md-3">
                <div *ngIf="f.name.errors?.['maxValue']">
                  Máximo 15 caracteres.
                </div>
              </div>
              <div class="col-md-3"></div>
            </div>
          </form>
          <div>
            <ngx-datatable #table ngx-resize-watcher [rows]="assignments" [rowHeight]="58" class="bootstrap core-bootstrap"
                        [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50" [scrollbarH]="true"
                        [limit]="basicSelectedOption"
                        [selected]="getSelectedRows()"
            [selectionType]="SelectionType.checkbox"
            (select)="onSelect($event)" 
                        [messages]="{emptyMessage: 'No hay información para mostrar', totalMessage: 'Total de facturas'}">
                        <ngx-datatable-column
                        [width]="30"
                        [sortable]="false"
                        [canAutoResize]="false"
                        [draggable]="false"
                        [resizeable]="false"
                        [headerCheckboxable]="true"
                        [checkboxable]="true"
                      >
                      </ngx-datatable-column>
                        <ngx-datatable-column [width]="155" name="Código" prop="billId">
                            <ng-template let-billId="value" ngx-datatable-cell-template>
                                <a (click)="DownloadPdf(billId)" target="_self" placement="right"
                  ngbTooltip="Descargar pdf">
                    {{ GetCodeById(billId) }}</a
                  ><br>
                  {{GetServiceCodeById(billId)}}
                                <!--<a [href]="GetURLById(id)" target="_blank">
                                    {{GetCodeById(id)}}</a>-->
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="148" name="Repartidor" prop="dealerName">
                            <ng-template let-dealer="value" ngx-datatable-cell-template>
                                <div placement="left" [ngbTooltip]="'Dealer Name'">
                                    <span class="d-inline-block text-truncate" style="max-width: 150px;">
                                        {{dealer | limitText}}</span>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="148" name="Vuelo" prop="flightCode">
                            <ng-template let-flight="value" ngx-datatable-cell-template>
                              <span class="d-inline-block text-truncate" style="max-width: 150px;">
                                {{ flight }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="148" name="Destino" prop="billCustomerModel">
                            <ng-template let-customer="value" ngx-datatable-cell-template>
                                <div placement="left" [ngbTooltip]="'Telefono: ' + customer?.Phone">
                                    <span class="d-inline-block text-truncate" style="max-width: 150px;">
                                        {{customer?.Name | limitText}}</span>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="70" name="Peso" prop="pounds">
                            <ng-template let-pounds="value" ngx-datatable-cell-template>
                                <span>{{pounds | number: '1.2-2'}}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [width]="90" name="Total" prop="total">
                            <ng-template let-total="value" ngx-datatable-cell-template>
                                <span>{{total | currency}}</span>
                            </ng-template>
                        </ngx-datatable-column>                        
                        <ngx-datatable-column name="Estado" [width]="200" [sortable]="false" prop="billStateCatalogName">
                            <ng-template ngx-datatable-cell-template let-state="value">
                              <span>{{ state }}</span>
                                <!--<button class="btn btn-outline-light text-primary dropbtn" [ngbPopover]="popoverTemplate" #popOver="ngbPopover"
                                    data-container="body" placement="left-top" [autoClose]="'outside'" type="button" id="defaultDropdown"
                                    aria-expanded="false">
                                    <em class="fa fa-bars"></em>
                                </button>
                                <ng-template #popoverTemplate style="overflow: visible;">
                                    <div>
                                        <button type="button" ngbTooltip="Desasignar" placement="left"
                                            class="btn btn-icon btn-outline-danger text-danger cursor-pointer mr-50" rippleEffect
                                            (click)="Unassign(assigmentId)">
                                            <span [data-feather]="'delete'"></span></button>
                                        <button type="button" ngbTooltip="Reasignar Repartidor" placement="left"
                                            class="btn btn-icon btn-outline-info text-info cursor-pointer mr-50" rippleEffect
                                            (click)="OpenAssignToDealer(assigmentId)">
                                            <span [data-feather]="'edit'"></span></button>
                                    </div>
                                </ng-template>--></ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-footer *ngIf="true">
                            <ng-template
                              ngx-datatable-footer-template
                              let-rowCount="rowCount"
                              let-pageSize="pageSize"
                              let-selectedCount="selectedCount"
                              let-curPage="curPage"
                              let-offset="offset"
                            >
                            <div class="d-flex justify-content-between w-100">
                              <div class="col-7 col-lg-7 col-sm-7" style="padding: 5px 10px">                
                                <div>Total facturas: {{ rowCount }} | Total libras: {{ totalPounds() | number :'1.2-2' }} | Total cobrado: {{ totalPaid() | currency}}</div>
                              </div>
                              <div class="col-5 col-lg-5 col-sm-5 align-items-center align-self-end text-right text-nowrap">
                                  <datatable-pager
                                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                                  [pagerRightArrowIcon]="'datatable-icon-right'"
                                  [pagerPreviousIcon]="'datatable-icon-prev'"
                                  [pagerNextIcon]="'datatable-icon-skip'"
                                  [page]="curPage"
                          [visiblePagesCount]="currentVisible"
                          [size]="pageSize"
                          [count]="rowCount"
                          [hidden]="!((rowCount / pageSize) > 1)"
                          (change)="table.onFooterPage($event)">                
                              </datatable-pager>
                                </div>
                            </div>
                            
                            
                              
                              
                            </ng-template>
                          </ngx-datatable-footer>
                    </ngx-datatable>
                    <ng-template #popoverTemplate> 
                      <div class="col-md-12 col-12">
                          <div class="row pb-1">
                              <div class="col-md-12">
                                  <button type="button" class="close" (click)="popOver.close()" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                  </button>
                              </div>              
                          </div>                     
                          <div class="modal-body" tabindex="0" ngbAutofocus>
                            <form [formGroup]="filterForm"  id="accountInformationForm">                  
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <label class="form-label" for="shippingType-input">
                                        Tipo de envío: 
                                      </label>
                                      <ng-select formControlName="shippingType" (clear)="resetTiposEnvio();" [clearable]="true" aria-describedby="shippingType-input" [items]="shippingTypes" (change)="FetchShippingsByType()" bindLabel="name" bindValue="id" placeholder="Tipos de envío"
                                      notFoundText="No hay información">
                                     </ng-select>    </div>
                                  </div>                                   
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <label class="form-label" for="code">
                                        Código Factura
                                      </label>
                                      <ng-autocomplete #ngAutoCompleteReactive [data]="billCodesFiltered" (inputCleared)="resetBillCodes();" formControlName="billCode" [initialValue]=""
                                          [placeholder]="placeholder" [searchKeyword]="keyword" notFoundText="No hay registros"
                                          [itemTemplate]="itemTemplateReactive" [notFoundTemplate]="notFoundTemplate" (inputChanged)='onChangeBillCode($event)'>
                                        </ng-autocomplete>
                                        <ng-template #itemTemplateReactive let-item>
                                          <a [innerHTML]="item"></a>
                                        </ng-template>
                                      
                                        <ng-template #notFoundTemplate let-notFound>
                                          <div [innerHTML]="notFound"></div>
                                        </ng-template>
                                        <!--
                                      <input type="text" id="flightcode" class="form-control"
                                         formControlName="billCode" /> 
                                        -->
                                      
                                    </div>
                                  </div> 
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <label class="form-label" for="flightCode">
                                          Código Vuelo: 
                                      </label>
                                      <!--<input type="text" id="flightcode" class="form-control"
                                         formControlName="flightCode" />    -->  
                                         <ng-autocomplete #ngAutoCompleteReactive [data]="flightCodesFiltered" (inputCleared)="resetFlightCodes();" formControlName="flightCode" [initialValue]=""
                                          [placeholder]="placeholder" [searchKeyword]="keyword" notFoundText="No hay registros"
                                          [itemTemplate]="itemTemplateReactive1" [notFoundTemplate]="notFoundTemplate1" (inputChanged)='onChangeFlightCode($event)'>
                                        </ng-autocomplete>
                                        <ng-template #itemTemplateReactive1 let-item>
                                          <a [innerHTML]="item"></a>
                                        </ng-template>
                                      
                                        <ng-template #notFoundTemplate1 let-notFound>
                                          <div [innerHTML]="notFound"></div>
                                        </ng-template>     
                                  </div>
                                  </div>                        
                                </div>      
                                <div class="row pt-2 pb-2">
                                  <div class="col-md-4">
                                    <button class="btn btn-outline-primary" type="button" rippleEffect (click)="resetFilters()"      
                                    >Borrar filtros</button>
                                  </div>
                                  <div class="col-md-4">
                              
                                  </div>
                                  <div class="col-md-4">
                                    <button class="btn btn-primary" type="button" rippleEffec (click)="Filter()"      
                                    >Buscar</button>
                                  </div>
                                </div>            
                            </form>
                          </div>
                      </div>               
                                                       
                    </ng-template>
          </div>
                          
        </div>
      </div>
    </section>
  </div>
</div>
